<template>
<div class=''>
  <div class="mian">
    <div class="left_box" :style="{background: 'url(' + initData.exampleDiagram + ')'}">
      <p class="description_of_the_medal" v-if="formDatas.badgeDesc">“{{ formDatas.badgeDesc  }}”</p>
      <img class="medal_thumbnail" v-if="formDatas.badgeIcon" :src="formDatas.badgeIcon">\
      <div class="declare_the_elite" v-if="formDatas.badgeName">
        <img src="https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/Vector%402x.png" style="margin-right: 8px;">
        {{formDatas.badgeName}}
        <img src="https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/Vector@2x(1).png" style="margin-left: 8px;">
      </div>

      <div class="mission_details" v-if="formDatas.badgeDistributionRelList">
        <h4>任务详情</h4>
        <ul>
          <li v-for="(item, index) in formDatas.badgeDistributionRelList" :key="index">
            <p>{{item.distributionName}}</p>
            <p><span style="color: #005CEB;">0</span>/{{item.distributionThreshold}}单</p>
          </li>
          <!-- <li>
            <p>小票当天上传</p>
            <p><span style="color: #005CEB;">2</span>/10单</p>
          </li>
          <li>
            <p>无重复上传记录</p>
            <p><span style="color: #005CEB;">已达成</span></p>
          </li>
          <li>
            <p>无恶意申报记录</p>
            <p><span style="color: #005CEB;">已达成</span></p>
          </li>
          <li>
            <p>账号使用状态安全健康</p>
            <p><span style="color: #005CEB;">已达成</span></p>
          </li> -->
        </ul>
        <h4>活动奖励</h4>
        <div class="number_of_declarations" v-for="(item, index) in formDatas.badgeBenefitRelList" :key="index" style="margin-bottom: 5px;">
          <div class="left_box_dec">
            <span>{{item.badgeBenefitValue}}</span>
             {{item.badgeBenefitType == 'money'?'元':'次'}}
          </div>
          <p class="dashed"></p>
          <div class="right_box_dec">
            <p v-if="item.badgeBenefitType=='money'">现金奖励</p>
            <p v-if="item.badgeBenefitType=='speed_declare'">极速券</p>
            <p>持有此勋章可享极速审核</p>
          </div>
        </div>

      </div>

      <button>去点亮</button>

    </div>
    <div class="right_box">
      <el-form ref="formDatas" :rules="rulesFormDatas" :model="formDatas" label-width="80px">
        <h4>1、基本设置</h4>
        <!-- <el-form-item label="勋章编码">
          <p>A115225</p>
        </el-form-item> -->
        <el-form-item label="勋章名称" prop="badgeName">
          <el-input v-model="formDatas.badgeName" size="small" :disabled="disabled" placeholder="请输入勋章名称"  maxlength="12" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="勋章类型" prop="badgeType">
          <el-select v-model="formDatas.badgeType" :disabled="disabled" placeholder="请选择勋章类型" size="small" clearable>
            <el-option
              v-for="item in medalTypeList"
              :key="item.value"
              :label="item.itemText"
              :value="item.itemValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="勋章周期" prop="medalCycleTime">

          <el-date-picker
            v-model="formDatas.medalCycleTime"
            type="datetimerange"
            size="small"
            :disabled="disabled"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']">
          </el-date-picker>

        </el-form-item>
        <el-form-item label="点亮时间" prop="badgeCollectionDeadlineDays">
        <div class="flex">
          <p>发放后</p>
          <el-input v-model.number="formDatas.badgeCollectionDeadlineDays" autocomplete="off" :disabled="disabled" style="width: 80px; margin: 0 10px;" clearable size="small"></el-input>
          <p>天内领取。</p>
        </div>
        </el-form-item>
        <el-form-item label="勋章图标" prop="badgeIcon">
            <div v-if="formDatas.badgeIcon" class="flex">
              <div class="mr10 flex item-end priview">
                <el-image
                  class="img"
                  :src="formDatas.badgeIcon"
                  alt="logo"
                  style="width: 100px;object-fit: cover;"
                  :preview-src-list="[formDatas.badgeIcon]"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button
                    type="text"
                    :disabled="disabled"
                    @click="handleRemove('badgeIcon')"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="el-upload__tip" style="margin-left: 10px;">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议图片尺寸200*200 <br />2.图片格式：png、jpg、bmp
                </span>
              </div>
            </div>

            <el-upload
              v-else
              class="upload flex"
              ref="upload"
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onError="uploadError"
              :onSuccess="cropUploadSuccess"
              :before-upload="beforeAvatarUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              :disabled="disabled"
            >
              <div class="flex upload-upload-btn">
                <div class="btn flex flex-column flex-center open-file" style="border: 1px solid #DCDFE6; width: 100px; height: 100px;">
                  <div class="add-wrapper">
                    <span
                      class="hmicon icon-hao pointer"
                      style="margin-right: 0px"
                    ></span>
                  </div>
                  <span class="gray">上传勋章图</span>
                </div>
              </div>

              <div class="el-upload__tip" slot="tip" style="margin-left: 10px;">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议图片尺寸200*200 <br />2.图片格式：png、jpg、bmp
                </span>
              </div>
            </el-upload>
        </el-form-item>
        <el-form-item label="勋章描述" prop="badgeDesc">
          <el-input type="textarea" v-model="formDatas.badgeDesc" :disabled="disabled" maxlength="30" :autosize="{ minRows: 4, maxRows: 4}" show-word-limit placeholder="请输入勋章描述" size="small" clearable></el-input>
        </el-form-item>
      
        <h4 class="verify">2、勋章发放条件</h4>
        <el-form-item label="" prop="badgeDistributionRelList">
          <el-table
            :data="formDatas.badgeDistributionRelList"
            style="width: 90%"
            border
            size="small"
            >
            <el-table-column
              label="条件名称" align="center" width="240">

              <template slot-scope="scope">
                  <el-input class="mistake" v-model="scope.row.distributionName" :disabled="disabled" placeholder="请输入条件名称" size="small" maxlength="20" show-word-limit></el-input>
              </template>

            </el-table-column>
            <el-table-column
              label="满足条件"
              align="center"
              width="240"
              >
              <template slot-scope="scope">
                  <el-select v-model="scope.row.tagId" :disabled="disabled" placeholder="请选择条件" size="small" clearable @change="selectAListOfCriteriaChang(scope.row.tagId, scope.$index)">
                    <el-option
                      v-for="item in selectAListOfCriteria"
                      :key="item.value"
                      :label="item.tagName"
                      :value="item.id">
                    </el-option>
                  </el-select>
              </template>
            </el-table-column>

            <el-table-column
              label="导购需达成的条件"
              align="center"
              width="240"
              >
              <template slot-scope="scope">
                  <el-select v-model="scope.row.distributionId" :disabled="disabled" placeholder="请选择导购需达成条件" size="small" @change="selectShoppingGuideScreening(scope.row.distributionId, scope.$index)" clearable>
                    <el-option
                      v-for="item in aListOfShoppingGuideConditions"
                      :key="item.value"
                      :label="item.frontViewName"
                      :value="item.id">
                    </el-option>
                  </el-select>
              </template>
            </el-table-column>


            <el-table-column
              label="目标字段"
              align="center"
              width="240"
              >  
              <template slot-scope="scope">
                <el-select v-model="scope.row.distributionFrontViewField" :disabled="disabled" placeholder="请选择目标字段" size="small" clearable>
                    <el-option
                      v-for="item in targetFieldOptions"
                      :key="item.value"
                      :label="item.fieldDesc"
                      :value="item.fieldName">
                    </el-option>
                  </el-select>
              </template>

            </el-table-column>




            <el-table-column
              label="目标值"
              align="center"
              width="240"
              >
              <template slot-scope="scope">
                  <el-input v-model="scope.row.distributionThreshold" :disabled="disabled" placeholder="请输入目标值" size="small"></el-input>
              </template>

            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="50"
              align="center"
              >
              <template slot-scope="scope">
                <div v-if="!disabled">
                  <el-button
                    v-if="scope.$index ==0"
                    @click.native.prevent="addRow(scope.$index, formDatas.badgeDistributionRelList)"
                    type="text"
                    size="small">
                    <i class="el-icon-circle-plus" style="font-size: 20px;"></i>
                  </el-button>

                  <el-button
                    v-if="scope.$index !=0"
                    @click.native.prevent="deleteRow(scope.$index, formDatas.badgeDistributionRelList)"
                    type="text"
                    size="small">
                    <i class="el-icon-remove-outline" color="#E50065" style="font-size: 20px;"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <h4 class="verify">3、发放权益</h4>
        
        <el-form-item label="" prop="badgeBenefitRelList">
         
        <div class="distribute_benefits flex" v-for="(item,index) in formDatas.badgeBenefitRelList" :key="index" style="margin-bottom: 10px;">
          <div class="left_bene">
            <el-form-item label="权益类型">
                <div class="flex">
                  <el-select v-model="item.badgeBenefitType" :disabled="disabled" placeholder="请选择权益类型" size="small" clearable>
                    <el-option
                      v-for="item in rightsList"
                      :key="item.value"
                      :label="item.itemText"
                      :value="item.itemValue">
                    </el-option>
                  </el-select>
                <el-input v-model="item.badgeBenefitValue" :disabled="disabled" size="small" style="width: 80px; margin: 0 20px;"></el-input><p>{{item.badgeBenefitType=='money'?'元':'次'}}</p>
                </div>
            </el-form-item>
            <el-form-item label="权益使用周期 领取后" placeholder="请输入数字" label-width="150px">
              <el-input v-model="item.benefitUseDeadlineDays" :disabled="disabled" placeholder="请输入数字" size="small"></el-input><p style="display: inline-block; margin-left: 10px;">天内有效</p>
            </el-form-item>
          </div>

          <div v-if="!disabled">
            <div v-if="index == 0" class="right_bene" @click="addBenefits(index, formDatas.badgeBenefitRelList)" style="cursor: pointer;">
              <i class="el-icon-circle-plus" style="font-size: 20px; color='#E50065'"></i>
            </div>
            
            <div v-if="index != 0" class="right_bene" @click="deleteBenefits(index, formDatas.badgeBenefitRelList)" style="cursor: pointer;">
              <i class="el-icon-remove-outline" style="font-size: 20px; color='#E50065'"></i>
            </div>
          </div>

        </div>
      </el-form-item>

        <el-form-item style="width: 80%; text-align: right; margin-top: 20px">
          <el-button v-if="$route.query.type == 'edit'" type="primary" @click="submitForm('formDatas', 'edit')" size="small">保存</el-button>
          <el-button v-if="!$route.query.type || $route.query.type == 'add'" type="primary" @click="submitForm('formDatas')" size="small">创建活动</el-button>
          <el-button size="small" @click="$router.go(-1)">返回</el-button>
        </el-form-item>

        
    </el-form>

    </div>
  </div>
 

</div>
</template>
<script>
export default {
  name: "",
  mixins: [],
  data() {
    const validPrizeList = (rule, val, callback) => {
      let flag = true;
      this.formDatas.badgeDistributionRelList.map(v => {
        if (!v.distributionName || !v.distributionId || !v.distributionFrontViewField || !v.distributionThreshold || !v.tagId) {
          flag = false;
        }

        // 判断value只能为数字格式
        if (!/^[0-9]*$/.test(v.distributionThreshold)) {
          return callback(new Error('目标值请输入大于或等于0数字'));
        }
        // if (v.distributionThreshold < 0) {
        //   return callback(new Error('目标值数字需大于或等于0'));
        // }

      });
      if (flag) {
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    };
    const badgeBenePrizeList = (rule, val, callback) => {
      let flag = true;
      this.formDatas.badgeBenefitRelList.map(v => {
        console.log(v);
        if (!v.badgeBenefitType || !v.badgeBenefitValue || !v.benefitUseDeadlineDays) {
          flag = false;
        }
        // 判断value只能为数字格式
        if (!/^[0-9]*$/.test(v.benefitUseDeadlineDays)) {
          return callback(new Error('目标值请输入大于或等于0数字'));
        }
      });
      if (flag) {
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    };
    return {
      targetFieldOptions:[],
      initData: {
        exampleDiagram:
          "https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/medal_bg1.jpg",
      },
      disabled: false,
      uploadShow: true,
      medalTypeList:[],
      selectAListOfCriteria:[],
      rightsList:[],
      aListOfShoppingGuideConditions:[],
      formDatas: {
        badgeName: '',
        badgeType: '',
        medalCycleTime: '',
        badgeRunStartTime: '',
        badgeRunEndTime: '',
        badgeCollectionDeadlineDays:'',
        badgeIcon: '',
        badgeDesc: '',
        badgeDistributionRelList:[
          {
            distributionName:'',
            distributionId:'',
            distributionFrontViewField:'',
            distributionThreshold:'',
            tagId:''
          }
        ],
        badgeBenefitRelList:[
          {
            badgeBenefitType:'',
            badgeBenefitValue:'',
            benefitUseDeadlineDays:''
          }
        ]
      },
      rulesFormDatas: {
        badgeName: [
            { required: true, message: '请输入勋章名称', trigger: 'blur' },
            { max: 16, message: '长度在 16 个字符之内', trigger: 'blur' }
          ],
          badgeType: [
            { required: true, message: '请选择勋章类型', trigger: 'change' }
          ],
          medalCycleTime:[
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          badgeCollectionDeadlineDays:[
            { required: true, message: '请输入天数', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                // 判断value只能为数字格式
                if (!/^[0-9]*$/.test(value)) {
                  return callback(new Error('请输入数字'));
                }else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          badgeIcon:[
            { required: true, message: '请上传勋章', trigger: 'blur' }
          ],
          badgeDesc: [
            { required: true, message: '请输入勋章描述', trigger: 'blur' }
          ],
          badgeDistributionRelList:[
            {
              required: true,
              validator: validPrizeList,
              trigger: "blur"
            }
          ],
          badgeBenefitRelList:[
            {
              required: true,
              validator: badgeBenePrizeList,
              trigger: "blur"
            }
          ]
        
      } 
    };
  },
  created() {
    
    this.getTheRedEnvelopeMedal();
    this.theTypeOfRedPacketBenefit();
    this.getSelectAListOfCriteria();
    
  },
  mounted() {
    if(this.$route.query.id){
      this.getEditList(this.$route.query.id);
    }
    if(this.$route.query.type == 'view'){
      this.disabled = true;
    }
  },
  methods: {
      cycleEditing(val){
        console.log(val);
      },
      // 获取编辑列表
      async getEditList(id) {
        const {result} = await this.$store.dispatch("queryRedpackageBadgeInfoById", {
          id
        });
        if(result){ 
          console.log(999999);
          console.log(result);
          let arrs = [result.badgeRunStartTime, result.badgeRunEndTime];
         
          result.badgeDistributionRelList.forEach((item, index) => {
            // 导购
            if(item.tagId){
              this.getAListOfShoppingGuideConditions(item.tagId);
            }
            // 目标
            if(item.distributionId){
              this.getQueryFieldListByIndex(item.distributionId);
            }
          }); 

          result.badgeBenefitRelList.forEach(item => {
            item.badgeBenefitType = item.badgeBenefitType.toString();
          }); 
          

          this.formDatas = result;
          this.$set(this.formDatas, 'medalCycleTime',arrs);
        }
      },


      // 红包勋章下拉
      async getTheRedEnvelopeMedal(){
        const {result} = await this.$store.dispatch('queryReportDataSource2')
        if(result){
          this.medalTypeList = result;
        }
      },
      // 红包权益类型redpackage_badge_benefit_type
      async theTypeOfRedPacketBenefit(){
        const {result} = await this.$store.dispatch('queryReportDataSource3')
        if(result){
          this.rightsList = result;
        }
      },
      // 选择条件selectAListOfCriteria
      async getSelectAListOfCriteria(){
        const {result} = await this.$store.dispatch('tagBasicInfoQueryTagListByCategoryId',{
          tagCategoryId: '3575d95f-6aa5-11ef-9096-08c0ebd4dda2'
        });
        if(result){
          this.selectAListOfCriteria = result;
        }
      },
      // 导购需达成的条件
      selectShoppingGuideScreening(val, index){
        this.formDatas.badgeDistributionRelList[index].distributionFrontViewField ='';
        this.getQueryFieldListByIndex(val);
      },

      // 条件
      selectAListOfCriteriaChang(val,index){
        this.formDatas.badgeDistributionRelList[index].distributionId ='';
        this.getAListOfShoppingGuideConditions(val);
      },
      // 目标字段
      async getQueryFieldListByIndex(val){
        const {result} = await this.$store.dispatch('queryFieldListByIndex',{
          tagDataId: val
        });
        if(result){
          this.targetFieldOptions = result;
        }
      },
      // 获取导购达成的条件
      async getAListOfShoppingGuideConditions(ids){
       
        const {result} = await this.$store.dispatch('queryTagBasicInfoAndDataRangeConfigListByTagBasicId',{
          id: ids
        });
        console.log(99999999999)
        console.log(result)
        if(result){
          this.aListOfShoppingGuideConditions = result.tagDataRangeConfigList;
        }
      },
      
      submitForm(formDatas, type) {
        this.$refs[formDatas].validate(async(valid) => {
          if (valid) {
            if(this.formDatas.medalCycleTime){
              this.formDatas.badgeRunStartTime = this.formDatas.medalCycleTime[0];
              this.formDatas.badgeRunEndTime = this.formDatas.medalCycleTime[1];
            }
            let theNameOfTheInterface ="saveRedpackageBadgeInfo";
            if(type == 'edit'){
              theNameOfTheInterface = 'editRedpackageBadgeInfo';
              this.formDatas.id = this.$route.query.id;
            }

             const {code} = await this.$store.dispatch(theNameOfTheInterface, this.formDatas);
             if(code == 0){
              localStorage.setItem('theCreationIsSuccessful', 2);
              this.$router.push({path: '/guiderCommission/redInvitationact/medalEventManagement?activityType=medal'});
             }
          } else {
            // 请填写完整信息
            this.$message({
              message: "请填写完整信息",
              type: "error"
            });
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 上传图片模块
      // 上传错误
      uploadError() {
        this.$message({
          message: "上传失败，请重试!",
          type: "warning"
        });
        this.uploadShow = false;
      },
      // 移除上传文件
      handleRemove(badgeIcon) {
        this.formDatas[badgeIcon] = "";
      },
       // 上传前对文件的大小的判断
      async beforeAvatarUpload(file) {
        const extension =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
        const extension2 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpeg";
        const extension3 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
        // const extension4 =
        //   file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
        // file.size单位为b，除以1024得到kb
        // const limitSize = file.size / 1024 <= 100;
        
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: "上传模板只能是 jpg、jpeg、png格式!",
            type: "warning"
          });
          abort()
          return false;
        }

        const extension5 = await this.checkImageSize(file);
        if(!extension5){
          abort()
          return false;
        }else {
          return true;
        }

    },
    // 校验
    async checkImageSize(file) {
      const reader = new FileReader();
      
      return new Promise((resolve, reject) => {
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            const { height, width } = image;
            if (height > 200 || width > 200) {
              this.$message({
                message: "上传的图片尺寸过大，请选择200x200像素以内的图片!",
                type: "warning"
              });
              resolve(false); // 传递结果
            } else {
              resolve(true); // 传递结果
            }
          };
          image.onerror = reject; // 处理图片加载错误
        };
        reader.onerror = reject; // 处理文件读取错误
        reader.readAsDataURL(file);
      });
    },
    // 正在上传
    uploading() {
      this.uploadShow = true;
    },
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.formDatas.badgeIcon = jsonData.result;
        this.uploadShow = false;
      }
    },

      // 表格
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      addRow(index, rows){
        rows.push({
          distributionName:'',
          distributionId:'',
          tagId:'',
          distributionFrontViewField:'',
          distributionThreshold:'',
        })
      },
      deleteBenefits(index, rows){
        rows.splice(index, 1);
      },
      // 添加权益
      addBenefits(index, row){
        row.push( {
            badgeBenefitType:'',
            badgeBenefitValue:'',
            benefitUseDeadlineDays:''
          })
      }

  },
};
</script>
<style>
.el-icon-circle-plus:before {
  color: #E50065;
}
.el-icon-remove-outline:before  {
  color: #E50065;
}
.el-table__body {
  width: 100% !important;
  table-layout: fixed !important;
}
</style>
<style lang='scss' scoped>

.verify::before{
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.flex {
  display: flex;
  align-items: center;
}
.mian {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background-size: cover;
  .left_box {
    width: 375px;
    min-height: 812px;
    background-color: #0e0e0e !important;
    margin-right: 10px;
    padding-bottom: 20px;
    background-size: 100% 812px !important;
    background-position: top center !important;
    background-repeat: no-repeat !important;
    .description_of_the_medal {
      width: 74%;
      font-size: 15px;
      color: #F2E8CA;
      line-height: 18px;
      text-align: center;
      margin: 20% auto 0 auto;
    }
    .medal_thumbnail {
      width: 140px;
      object-fit: cover;
      margin: 15% auto 0 auto;
      display: block;
    }
    .declare_the_elite {
      font-weight: 600;
      font-size: 30px;
      color: #FBE8C9;
      line-height: 35px;
      margin-top: 6%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 19px;
      }
    }


    .mission_details {
      width: 345px;
      background: #FFF7EC;
      border-radius: 14px;
      margin: 23px auto 0 auto;
      padding: 13px 13px 16px 16px;
      box-sizing: border-box;
      h4 {
        font-weight: 600;
        font-size: 15px;
        color: #37342F;
        line-height: 18px;
        margin: 0;
        margin-bottom: 14px;
      }
      ul{
        margin-bottom: 9px;
        li {
          font-size: 14px;
          color: #000000;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;
        }
      }

      .number_of_declarations {
        width: 321px;
        background: #37342F;
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding: 11px 16px;
        box-sizing: border-box;
        .left_box_dec {
          font-size: 12px;
          color: #FCEFC8;
          line-height: 14px;
          position: relative;
          span {
            font-weight: 600;
            font-size: 31px;
            color: #FCEFC8;
            line-height: 31px;
          }
        }
        .dashed{
          width: 1px;
          height: 46px;
          border-left: 1px dashed #FCEFC8;
          margin: 0 21px 0 12px;
        }
        .right_box_dec {
          color: #868071;
          // p标签首选择器
          p:first-child {
            font-size: 14px;
            line-height: 16px;
            font-weight: 600;
            margin-bottom: 4px;
          }
          p:last-child {
            font-size: 12px;
            line-height: 14px;
          }
        }
      }


    }

    button {
      width: 334px;
      height: 38px;
      border-radius: 22px;
      border: 1px solid #FCE6C9;
      background: #0F0F0F;
      display: block;
      margin: 11px auto 0 auto;
      font-size: 16px;
      color: #FCE6C9;
      line-height: 19px;
    }


  }
  .right_box {
    height: 800px;
    overflow-y: scroll;
    padding-bottom: 20px;
    background-color: #fff;
    width: calc(100% - 385px);
    min-height: 667px;
    padding-left: 20px;
    box-sizing: border-box;
    h4 {
      font-size: 16px;
      font-weight: 400;
    }
    .distribute_benefits {
      width: 800px;
      border: 1px solid #EBEEF5;
      justify-content: space-around;
      padding-top: 20px;
    }
  }

    /* 隐藏滚动条 */
  .right_box::-webkit-scrollbar {
      display: none;
  }
 
  

}
</style>
